import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { EwpNav } from "./components/EwpNav";
import { RequireAuth } from "./components/RequireAuth";
import { LocalOnlyPage } from "./pages/LocalOnlyPage";
import { PorchBoxLabelPage } from "./pages/PorchBoxLabelPage";
import { PorchDatasetPage } from "./pages/PorchDatasetPage";
import { PorchReviewDetailPage } from "./pages/PorchReviewDetailPage";
import { PorchReviewListPage } from "./pages/PorchReviewListPage";
import { RoomDatasetPage } from "./pages/RoomDatasetPage";

function RedirectToLabel() {
  const loc = useLocation();
  const { pageId } = useParams<{ pageId?: string }>();
  return <Navigate to={pageId ? `/label/${pageId}${loc.search}` : `/label${loc.search}`} replace />;
}

export default function App() {
  if (import.meta.env.PROD) {
    return <LocalOnlyPage />;
  }

  const loc = useLocation();
  const fullBleed = loc.pathname === "/label" || loc.pathname.startsWith("/label/");
  return (
    <RequireAuth>
      <div className="flex h-full flex-col">
        <EwpNav />
        <main className={fullBleed ? "flex-1 overflow-hidden" : "mx-auto w-full max-w-7xl flex-1 px-4 py-6"}>
          <Routes>
            <Route path="/" element={<Navigate to="/label?pack=label-all" replace />} />
            <Route path="/label" element={<PorchBoxLabelPage />} />
            <Route path="/label/:pageId" element={<PorchBoxLabelPage />} />
            <Route path="/porch-review" element={<PorchReviewListPage />} />
            <Route path="/porch-review/dataset" element={<PorchDatasetPage />} />
            <Route path="/porch-review/label" element={<RedirectToLabel />} />
            <Route path="/porch-review/label/:pageId" element={<RedirectToLabel />} />
            <Route path="/porch-review/:itemId" element={<PorchReviewDetailPage />} />
            <Route path="/ewp-ai/porch-review" element={<PorchReviewListPage />} />
            <Route path="/ewp-ai/porch-review/dataset" element={<PorchDatasetPage />} />
            <Route path="/ewp-ai/porch-review/label" element={<RedirectToLabel />} />
            <Route path="/ewp-ai/porch-review/label/:pageId" element={<RedirectToLabel />} />
            <Route path="/ewp-ai/porch-review/:itemId" element={<PorchReviewDetailPage />} />
            <Route path="/room-review" element={<RoomDatasetPage />} />
            <Route path="/room-review/label" element={<RedirectToLabel />} />
            <Route path="/room-review/label/:pageId" element={<RedirectToLabel />} />
            <Route path="/ewp-ai/room-review" element={<RoomDatasetPage />} />
            <Route path="/ewp-ai/room-review/label" element={<RedirectToLabel />} />
            <Route path="/ewp-ai/room-review/label/:pageId" element={<RedirectToLabel />} />
            <Route path="*" element={<Navigate to="/label?pack=label-all" replace />} />
          </Routes>
        </main>
      </div>
    </RequireAuth>
  );
}
